import React, { SetStateAction, useState } from "react";
import dayjs from "dayjs";

function Table({ data, activeTab, setActiveTab }: { data: any; activeTab: string; setActiveTab: SetStateAction<any> }) {
  return (
    <div className="w-full rounded-md bg-white p-5">
      <div className="mb-4 border rounded-md border-gray-200 w-fit">
        <ul
          className="flex flex-wrap -mb-px text-sm font-medium text-center"
          id="default-styled-tab"
          data-tabs-toggle="#default-styled-tab-content"
          data-tabs-active-classes="text-purple-600 hover:text-purple-600 dark:text-purple-500 dark:hover:text-purple-500 border-purple-600 dark:border-purple-500"
          data-tabs-inactive-classes="dark:border-transparent text-gray-500 hover:text-gray-600 dark:text-gray-400 border-gray-100 hover:border-gray-300 dark:border-gray-700 dark:hover:text-gray-300"
          role="tablist"
        >
          <li className="me-2" role="presentation">
            <button
              onClick={() => {
                setActiveTab("all");
              }}
              className={`${
                activeTab === "all" ? "text-primary" : "text-gray-400"
              }  text-sm inline-block p-2 pb-0 mb-2 border-b rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300`}
              id="web-visit-styled-tab"
              data-tabs-target="#styled-web-visit"
              type="button"
              role="tab"
              aria-controls="web-visit"
              aria-selected="false"
            >
              Over all
            </button>
          </li>
          <li className="me-2">
            <button
              onClick={() => {
                setActiveTab("sub");
              }}
              className={`${
                activeTab === "sub" ? "text-primary" : "text-gray-400"
              }  text-sm inline-block p-2 pb-0 mb-2 border-b rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300`}
              id="subscriptions-styled-tab"
              data-tabs-target="#styled-subscriptions"
              type="button"
              role="tab"
              aria-controls="subscriptions"
              aria-selected="false"
            >
              Subscriptions
            </button>
          </li>
          <li>
            <button
              onClick={() => {
                setActiveTab("free");
              }}
              className={`${
                activeTab === "free" ? "text-primary" : "text-gray-400"
              }  text-sm inline-block p-2 pb-0 mb-2 border-b rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300`}
              id="subscribers-styled-tab"
              data-tabs-target="#styled-subscribers"
              type="button"
              role="tab"
              aria-controls="subscribers"
              aria-selected="false"
            >
              Free Trial Activation
            </button>
          </li>
        </ul>
      </div>
      <table className="w-full">
        <tbody>
          {data?.map((each: any) => (
            <tr className="font-light text-sm text-primary w-full ">
              <td className="border-b pt-5 pb-1/2">{each?.type}</td>
              <td className="border-b pt-5 pb-1/2">{each?.phone}</td>
              <td className="border-b pt-5 pb-1/2">{each?.amount}</td>
              <td className="border-b pt-5 pb-1/2">{each?.plan.frequency}</td>
              <td className="border-b pt-5 pb-1/2">{each?.plan.type}</td>
              <td className="border-b pt-5 pb-1/2">{dayjs(each?.date).format("DD-MMMM-YYYY HH:MM")}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Table;
